import React, {memo, useEffect, useState} from "react";
import Autocomplete from "@mui/lab/Autocomplete/Autocomplete";
import TextField from "@mui/material/TextField";
import Api from "../../../../utils/api";
import {useLocation, useNavigate} from "react-router-dom";
import queryString from 'query-string';

const BrandAutoComplete = memo((props) => {

    const history = useNavigate()
    const location = useLocation();
    const query = queryString.parse(location.search);

    const handleChangeSearchInput = (event) => {

        const modifiedQuery = {...query, [event.target.name]: event.target.value}
        for (const key of Object.keys(modifiedQuery)) {
            if (modifiedQuery[key] === "") {
                delete modifiedQuery[key];
            }
        }

        history(
            `${location.pathname}?${queryString.stringify(modifiedQuery)}`,
            { replace: true }
        );

        let search = filter;

        search[event.target.name] = event.target.value;

        setFilter({...search})
        autoCompleteHandleSelect(event)
        autoCompleteHandleChange()
    }

    const { onChange, values } = props;

    const [options, setOptions] = useState(values ? values : []);
    const [typingTimeout, setTypingTimeout] = useState(0);
    const [filter, setFilter] = useState({
        status: query.status || 1,
        count: query.count || -1,
        title: query.title || "",
        id: query.id || "",
    });

    const instance = new Api();

    const autoCompleteHandleSelect = (id) =>
    {
        // return value of props
        onChange(id);
    };

    const autoCompleteHandleChange = (event) =>
    {
        let val = event.target.value;

        if (typingTimeout) {
            clearTimeout(typingTimeout);
        }

        let loop = setTimeout(async () => {
            await new Promise(resolve => {
                resolve(instance.get('/products/brands/autocomplete', {'term': val}).then((response) => {
                    if (typeof response != "undefined") {
                        setOptions(response);
                    }
                }));
            })
        }, 500);

        setTypingTimeout(loop);

    };

    return(
        <Autocomplete
            onChange={((event, value) => handleChangeSearchInput(event))}
            options={options}
            getOptionLabel={option => option.title}
            renderInput={params => (
                <TextField
                    {...params}
                    fullWidth
                    margin={"dense"}
                    label="برند"
                    variant="outlined"
                    InputLabelProps={{
                        shrink: true,
                    }}
                    value={ '-1'}
                />
            )}
        />
    );
});

export default BrandAutoComplete